import {
    chakra, Text, Box
} from '@chakra-ui/react';

export const VerifyEmailLogo = chakra(Box, {
    label: 'VerifyEmailLogo',
    baseStyle: {
        m: '0 auto',
        w: 'fit-content'
    }
});

export const VerifyEmailHeaderText = chakra(Text, {
    label: 'VerifyEmailHeaderText',
    baseStyle: {
        fontSize: '34px',
        lineHeight: '42px',
        letterSpacing: '0.25px',
        textAlign: 'center'
    }
});

export const VerifyEmailBodyText = chakra(Text, {
    label: 'VerifyEmailBodyText',
    baseStyle: {
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.15px',
        color: 'portal.grey04',
        w: '640px',
        m: '24px auto 16px'
    }
});

export const ContactUsText = chakra(Text, {
    label: 'ContactUsText',
    baseStyle: {
        fontSize: '12px',
        lineHeight: '28px',
        letterSpacing: '-0.228571px',
        color: '#5C6C7F',
        mt: '16px'
    }
});

export const ContactUsLink = chakra('a', {
    label: 'ContactUsLink',
    baseStyle: {
        color: 'portal.blue07',
        textDecoration: 'underline',
        ml: '5px'
    }
});

export const TextFieldWrapper = chakra(Box, {
    label: 'TextFieldWrapper',
    baseStyle: {
        m: '26px auto 0',
        w: '420px'
    }
});

export const VerifyEmailButton = chakra('button', {
    label: 'VerifyEmailButton',
    baseStyle: {
        w: '150px',
        h: '52px',
        bgColor: 'portal.blue07',
        color: 'portal.white01',
        borderRadius: '80px',

        _focus: { boxShadow: 'none' },
        _hover: { bgColor: 'portal.blue08' }
    }
});

export const DoItLaterButton = chakra('button', {
    label: 'DoItLaterButton',
    baseStyle: {
        w: '150px',
        h: '52px',
        bgColor: 'portal.white01',
        color: 'portal.blue07',
        borderRadius: '80px',
        border: '1px solid rgba(0, 171, 232, 0.5)',
        ml: '10px',

        _focus: { boxShadow: 'none' },
        _hover: { bgColor: 'portal.blue09' }
    }
});
